import React from "react";
import { Route, Switch } from "react-router";

import SecuredComponent from "./securedComponent";
//import NoAuth from "./noAuth";

import Dashboard from "../pages/dashboard";
import Messages from "../pages/messages";
import Settings from "../pages/settings";
import Login from "../pages/login";
import NotFound from "../pages/notFound";
import Loadable from "react-loadable";
import Onboarding from "../pages/onboarding";
import Club from "../pages/club";
import Players from "../pages/players";
import PastReservations from "../pages/reservations/past";
import WaitingList from "../pages/reservations/waitingList";
import Courts from "../pages/courts";
import ActiveReservations from "../pages/reservations/active";
import Loader from "./loader";
import Leaderboards from "../pages/leaderboards";
import Matches from "../pages/matches";
import Code from "../pages/code";
import Deals from "../pages/deals";
import Shop from "../pages/shop";
import campaign from "../pages/campaign";
import AlterPassword from "../pages/alterPassword";
import TOSReview from "../pages/tosReview";
import ClubWidget from "../pages/clubWidget";
import WithLayout from "./withLayout";
import ClubsWidgetPage from "../pages/clubsWidget";
export { Dashboard, Messages, Login, NotFound };

const LoadableRegisterPage = Loadable({
	loader: () => import("../pages/register"),
	loading: Loader,
});

const Routes = () => (
	<Switch>
		<WithLayout exact path="/" component={SecuredComponent(Dashboard)} />
		<WithLayout path="/players" component={SecuredComponent(Players)} />

		<WithLayout exact path="/messages/conversation/:id" component={SecuredComponent(Messages)} />
		<WithLayout exact path="/messages/new" component={SecuredComponent(Messages)} />
		<WithLayout exact path="/messages" component={SecuredComponent(Messages)} />

		<WithLayout exact path="/courts" component={SecuredComponent(Courts)} />
		<WithLayout exact path="/courts/results" component={SecuredComponent(Courts)} />
		<WithLayout exact path="/settings/account" component={SecuredComponent(Settings)} />
		<WithLayout exact path="/settings/profile" component={SecuredComponent(Settings)} />
		<WithLayout exact path="/settings/billing" component={SecuredComponent(Settings)} />
		<WithLayout exact path="/settings/notifications" component={SecuredComponent(Settings)} />
		<WithLayout exact path="/settings/privacy" component={SecuredComponent(Settings)} />
		<WithLayout exact path="/settings/memberships" component={SecuredComponent(Settings)} />

		<WithLayout exact path="/reservations/active" component={SecuredComponent(ActiveReservations)} />
		<WithLayout exact path="/reservations/past" component={SecuredComponent(PastReservations)} />
		<WithLayout exact path="/reservations/waiting-list" component={SecuredComponent(WaitingList)} />
		<WithLayout exact path="/reservations/active/:id" component={SecuredComponent(ActiveReservations)} />

		<WithLayout exact path="/deals" component={SecuredComponent(Deals)} />
		<WithLayout exact path="/deals/:campaign" component={SecuredComponent(campaign)} />
		<WithLayout exact path="/campaign/:campaign" component={SecuredComponent(campaign)} />
	
		<WithLayout exact path="/shop" component={SecuredComponent(Shop)} />

		<WithLayout exact path="/matches" component={SecuredComponent(Matches)} />
		<WithLayout exact path="/championship/:id" component={SecuredComponent(Leaderboards)} />
		<WithLayout exact path="/championships" component={SecuredComponent(Leaderboards)} />

		<WithLayout path="/onboarding" component={SecuredComponent(Onboarding)} />
		<WithLayout exact path="/club/:uuid" component={SecuredComponent(Club)} />
		<Route exact path="/club/:uuid/widget" component={ClubWidget} />
		<Route exact path="/club/:uuid/swisstennis-widget" component={ClubWidget} />
		<Route exact path="/club/:uuid/stadt-zurich-widget" component={ClubWidget} />
		<Route exact path="/clubsWidget" component={ClubsWidgetPage} />

		<WithLayout path="/tos-review" component={SecuredComponent(TOSReview)} />
		<WithLayout path="/alter-password" component={SecuredComponent(AlterPassword)} />

		<WithLayout exact path="/login" component={Login} />
		<WithLayout exact path="/register" component={LoadableRegisterPage} />
		<WithLayout exact path="/code/:code" component={Code} />

		<WithLayout component={NotFound} />
	</Switch>
);

export default Routes;
